import * as React from 'react';

import { BookingWidgetTheme } from 'lib/themes/themes';

export const BookingWidgetThemeContext = React.createContext<BookingWidgetTheme>('DEFAULT');
